<template>
	<div class="socials">
		<a
			v-for="medium in socials"
			:key="medium.ID"
			:class="medium.platform"
			:href="medium.url"
			:aria-label="medium.platform"
			target="_blank"
		>
			{{ medium.platform }}
		</a>
	</div>
</template>

<script setup>
defineProps({
	socials: { type: Array, default: () => [] },
});
</script>

<style lang="scss" scoped>
.socials {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	flex-flow: row wrap;
	width: 100%;
	margin: 0;
	font-family: var(--body-font-family);

	a {
		display: flex;
		align-items: center;
		text-align: center;
		margin: 0 0 0 10px;
		letter-spacing: 1px;
		text-decoration: none;
		font-weight: 400;
		font-size: 18px;
		text-transform: uppercase;
		color: var(--primary-background-color);
		border-bottom: 1px solid;
		line-height: 22px;

		&:hover {
			color: var(--cta-color-hover);
		}
	}
}

@media (max-width: 900px) {
	.socials {
		a {
			margin: 0;
		}
	}
}

@media (max-width: 600px) {
	.socials {
		a {
			font-size: 20px;
		}
	}
}
</style>
